import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import useTranslation from 'Hooks/useTranslation';
import TextInput from 'Components/FormComponents/TextInput';
import { NO_EMPTY_NO_EMPTY_SPACES } from 'Constants/Regex';
import DragAndDrop from './Containers/DragAndDrop';
import useDragAndDrop from './Hooks/useDragAndDrop';
import Question from './Components/Question';
import { Container, QuestionsContainer } from './style';

function QuestionsTab({ formData, setFormData, setUnchanged }) {
  const [questions, setQuestions] = useState(formData?.questions);
  const [examName, setExamName] = useState(formData?.evaluationName);
  const { t2 } = useTranslation('EditCourse');

  useEffect(() => {
    setQuestions(formData.questions);
  }, [formData]);

  const blurHandler = event => {
    const formDataCopy = _.cloneDeep(formData);
    formDataCopy.evaluationName = event.target.value;

    if (examName.match(NO_EMPTY_NO_EMPTY_SPACES) || examName.length < 6) {
      setFormData({
        ...formData,
        errors: {
          ...formData.errors,
          evaluationName: t2('FormErrorEvaluationName'),
        },
      });

      return;
    }

    delete formDataCopy.errors.evaluationName;
    setUnchanged(false);
    setFormData({
      ...formDataCopy,
    });
  };

  const handleNameChange = event => {
    setExamName(event.target.value);
  };

  const { onDragEnd } = useDragAndDrop({
    questions,
    setQuestions,
    formData,
    setFormData,
    setUnchanged,
  });

  return (
    <Container>
      <TextInput
        name="evaluationName"
        label={t2('ExamName')}
        color="MexlogGreen"
        value={examName}
        onChange={handleNameChange}
        onBlur={blurHandler}
        errortext={formData?.errors?.evaluationName}
      />
      <DragAndDrop onDragEnd={onDragEnd} type="Questions" droppableId="question">
        <QuestionsContainer>
          {questions?.map((question, index) => (
            <Question
              key={question.id}
              position={index}
              question={question}
              questions={questions}
              setQuestions={setQuestions}
              formData={formData}
              setFormData={setFormData}
              setUnchanged={setUnchanged}
              isLastItem={index === questions.length - 1}
            />
          ))}
        </QuestionsContainer>
      </DragAndDrop>
    </Container>
  );
}

export default QuestionsTab;
